import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@nobia/zeus-components/lib/buttons'
import styled, { prop } from '@nobia/zeus-components/lib/styled'
import { trackEvent } from '@nobia/zeus-components/lib/analytics'
import { Container, Row, Column } from '@nobia/zeus-components/lib/grid'
import { SubHeadline } from '@nobia/zeus-components/lib/text'
import ProductRow from '../product-row/ProductRow'
import LoginModal from '../login-modal/LoginModal'
import ShareModal from '../share-modal/ShareModal'
import ReminderModal from '../reminder-modal/ReminderModal'

const CustomColumn = styled(Column)`
  padding: 3% 2%;
`

const ProductListHeader = styled(Column)`
  background-color: ${prop('theme.colors.backgroundSecondary')};
  padding: 0 20px;
`

const AddToMyAccountButton = styled(Button)`
  margin: 0;
  padding: 10px;
  width: 100%;
  height: 50px;
`
const CustomRow = styled(Row)`
  margin-bottom: 30%;
`

const StyledContainer = styled(Container)`
  padding: 0;
`

const trackAnalyticsEvent = () => {
  trackEvent('MC-ESH Share Wishlist', 'MC-ESH Click', 'Share Wishlist Opened')
}

class ProductList extends Component {
  reminderInterval = 2 * 60 * 1000 // 2 min
  timer = null

  state = {
    showLoginModal: false,
    showShareModal: false,
    showReminderModal: false,
  }

  componentDidMount() {
    this.timer = setInterval(this.showReminder, this.reminderInterval)
  }

  componentWillUnmount() {
    clearInterval(this.timer)
  }

  showReminder = () => {
    if (
      this.props.wishlist.length > 0 &&
      !this.state.showShareModal &&
      !this.state.showLoginModal
    ) {
      this.setState({ showReminderModal: true })
    }
  }

  toggleLoginModal = () => {
    this.setState({ showLoginModal: !this.state.showLoginModal })
  }

  toggleShareModal = () => {
    this.setState({ showShareModal: !this.state.showShareModal })
  }

  clickHandler = () => {
    this.toggleShareModal()
    trackAnalyticsEvent()
  }

  toggleReminderModal = () => {
    if (this.state.showReminderModal) {
      // if we are going to close it
      clearInterval(this.timer)
      this.timer = setInterval(this.showReminder, this.reminderInterval)
    }
    this.setState({ showReminderModal: !this.state.showReminderModal })
  }

  render() {
    return (
      <StyledContainer>
        <Row>
          <ProductListHeader>
            <CustomColumn xs={12}>
              <SubHeadline>
                My saved products ({this.props.wishlist.length})
              </SubHeadline>
              <Row>
                <CustomColumn xs={8}>
                  <AddToMyAccountButton
                    kind={'primary'}
                    onClick={this.toggleLoginModal}
                  >
                    Add to my account
                  </AddToMyAccountButton>
                </CustomColumn>
                <CustomColumn xs={4}>
                  <AddToMyAccountButton
                    kind={'secondary'}
                    onClick={this.clickHandler}
                  >
                    Share
                  </AddToMyAccountButton>
                </CustomColumn>
              </Row>
            </CustomColumn>
          </ProductListHeader>
        </Row>
        <CustomRow>
          {this.props.wishlist.map(x => (
            <ProductRow
              key={x.id}
              item={x}
              handleRemove={this.props.handleRemove}
            />
          ))}
        </CustomRow>
        <LoginModal
          open={this.state.showLoginModal}
          handleClose={this.toggleLoginModal}
        />
        <ShareModal
          open={this.state.showShareModal}
          handleClose={this.toggleShareModal}
          wishlist={this.props.wishlist}
        />
        <ReminderModal
          open={this.state.showReminderModal}
          handleClose={this.toggleReminderModal}
        />
      </StyledContainer>
    )
  }
}

ProductList.propTypes = {
  wishlist: PropTypes.array.isRequired, // eslint-disable-line
  handleRemove: PropTypes.func.isRequired,
}

export default ProductList
